import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import CasinoTransaction from '../../../../casino/Api/Models/CasinoTransaction';
import { mountReactNode } from '../../../../base/reactMount';
import { formatCurrency, formatLongWithTimezone } from '../../../../utils/formatters';

interface Props {
    token: string;
}

function SingleCasinoTransaction({ token }: Props) {
    const [hasError, setHasError] = useState(false);
    const [transaction, setTransaction] = useState<CasinoTransaction>(null);
    const url = '/casino/api/internal/account/transactions/transaction';
    const { t } = useTranslation();

    useEffect(() => {
        const params = {
            id: token,
        };

        axios
            .get(url, { params })
            .then((response) => setTransaction(response.data.transaction))
            .catch(() => setHasError(true));
    }, []);

    function getTransactionDetails() {
        return (
            <div>
                <p>
                    {t('myTransactions.ID')}: <span className="font-bold">{transaction.id}</span>
                </p>
                <p>
                    {t('myTransactions.transactionDate')}:{' '}
                    <time dateTime={formatLongWithTimezone(transaction.created_at, transaction.user.timezone)}>
                        {formatLongWithTimezone(transaction.created_at, transaction.user.timezone)}
                    </time>
                </p>
                <p>
                    {t('myTransactions.transactionValue')}:{' '}
                    <span className="green font-bold">
                        {transaction.amount_manager === 0
                            ? t('myTickets.noWinnings')
                            : formatCurrency(transaction.amount_manager, 2)}
                    </span>
                </p>
                <p>
                    {t('myTransactions.type')}:{' '}
                    <span className="green font-bold">
                        {transaction.action === 'win' && transaction.amount_manager === 0
                            ? t('myTransactions.lose')
                            : t(`myTransactions.${transaction.action}`)}
                    </span>
                </p>
                <p>
                    {t('casino.game.name')}:{' '}
                    <span className="green font-bold">
                        <a href={window.CASINO_PLAY_URL.replace('slug', transaction.casino_game.slug)}>
                            {transaction.casino_game.name}
                        </a>
                    </span>
                </p>
                <p>
                    {t('myTransactions.is_canceled')}:{' '}
                    <span>
                        {!transaction.is_canceled ? (
                            <i className="fas fa-times text-danger" />
                        ) : (
                            <i className="fas fa-check text-success" />
                        )}
                    </span>
                </p>
            </div>
        );
    }

    function getErrorMessage() {
        if (hasError) {
            return (
                <div>
                    <p>{t('myTransactions.transactionNotAvailable')}</p>
                </div>
            );
        }

        return null;
    }

    return transaction ? getTransactionDetails() : getErrorMessage();
}

const element = document.getElementById('component--casino-account-transaction-transaction');
if (element) {
    mountReactNode(element, <SingleCasinoTransaction token={element.dataset.token} />);
}
